//simple pluralization function that handles many common nouns
export default(count, noun, suffix = 's') => (
  `${count} ${noun}${count !== 1 ? suffix : ''}`
);
